export const usernameRegexp = /^[A-Za-z0-9]+$/;
export const alphabeticRegexp = /^[A-Za-z]+$/;
export const onetimeCodeRegexp = usernameRegexp;
export const twoFactorOnetimeCodeRegexp = /^[0-9]*$/;
export const katakanaRegexp = /^[ァ-ンーヴヷヺ]+$/;
export const passwordRegexp = /^[A-Za-z0-9!"#$%&'()*+\-.,/:;<=>?@[\\\]^_`{|}~]+$/;
export const postalCodeRegexp = /^([0-9]{3}-[0-9]{4}|[0-9]{7})$/;
// 060 は総務省が指定した携帯電話の番号帯だが、SMS配信サービス(Accrete)が配信を提供していないため許可しない
// 提供が再開されたら 0[789]0 を 0[6789]0 に戻す
// FYI https://github.com/medley-inc/pharms/issues/14195
export const mobilePhoneRegexp = /^0[789]0[0-9]{8}$|^(0[789]0)-[0-9]{4}-[0-9]{4}$/;
export const bankAccountHolderNameRegexp = /^[ァ-ヴＡ-Ｚ０-９．（）ー‐－\u3000]+$/;
export const bankAccountHolderNameSymbolsRegexp = /^[．（）ー‐－\u3000]+$/;
export const numberRegexp = /^[0-9０-９]+$/;
export const halfWideNumberRegexp = /^[0-9]+$/;
export const numberOrHyphenRegexp = /^[0-9０-９-‐−ー―ｰ－]+$/;
export const timeRegexp = /^(([01][0-9]|2[0-3]):[03]0|24:00)$/;
export const businessHourTimeRegexp = /^(([01][0-9]|2[0-3]):(00|15|30|45)|24:00)$/;
export const certNameRegexp = usernameRegexp;
export const loginPageNoindexRegexp = /login\?next/;
export const loginPageRegexp = /login/;
export const corporateNumberRegexp = /^[0-9０-９]{13}$/;
export const onlineQualificationConfirmationUrlRegexp =
  /^https:\/\/kdg(-st)?\.onshikaku\.org\/online-care.*mi_code=.*/;
export const emailRegexp =
  /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
export const fullWidthOnlyRegexp = /^[^\x20-\x7E｡-ﾟ]+$/;
export const halfWidthOnlyRegexp = /^[\x20-\x7E｡-ﾟ]+$/;
export const asciiOnlyRegexp = /^[\x20-\x7E]+$/;
export const postalCodeUpperRegexp = /^[0-9]{3}$/;
export const postalCodeLowerRegexp = /^[0-9]{4}$/;
export const notBlankRegexp = /\S/;
